export default `Canny('identify', {
  appID: 'YOUR_APP_ID',
  user: {
    created: new Date(viewer.created).toISOString(), // optional
    email: viewer.email,
    id: viewer.id,
    name: viewer.name,
  },
  hash: viewer.userGeneratedHash,
});`;
